/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React from 'react';

/* APP E SERVIÇOS */

import { useAppContextoReact } from "../../servicos/app/AppContextoReact.tsx";

/* FORM E FIELDS */

import { Controller, useForm } from "react-hook-form";
import { Grid, } from '@mui/material';
import TextField from '@mui/material/TextField';

/* INTERFACES E ENUMERAÇÕES */

import { IRetornoAjaxEntidades } from '../../servicos/entidades/Entidades_FrontAPI.ts';
import { User } from 'firebase/auth';
import { IFormStateEntidades, bananinhaListError, validacao } from '../../servicos/IFormularios.ts';
import EntidadesController from '../../servicos/entidades/EntidadesController.ts';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import AddEditComponent from '../../componentes/formularios/_AddEditComponent.tsx';
import {EFORM} from '../../componentes/formularios/EFORM.tsx';

interface IPropsFormLightbox
{
	operacao: EFORM
	entidade: IFormStateEntidades
	setEntidade: (entidade: IFormStateEntidades) => void
	openDialog: boolean
	listViews: boolean
	setOpenDialog: (openDialog: boolean) => void
	callBack: () => void
}

const FormDialog = (props:IPropsFormLightbox) =>
{
	const appContext = useAppContextoReact();
	const EntController = new EntidadesController();

	const [user, setUser] = React.useState<User|null|undefined>(null);
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);
	const [onSubmiting, setOnSubmiting] = React.useState<boolean>(false);
	const [open, setOpen] = React.useState(false);

	const { control, handleSubmit, reset, setValue, formState: { errors }} 
		= useForm<IFormStateEntidades>({reValidateMode: "onSubmit", criteriaMode: "all", shouldFocusError: false, defaultValues: props.entidade});

	React.useEffect(() =>
	{
		setUser(appContext?.usuario.user)
		setUserRolerAdmin(appContext.permissao.administrador)
	},[appContext])
    
	React.useEffect(() =>
	{ 
		reset(props.entidade);
	}, [props.entidade]);
	
	const handleSuccess = React.useCallback((msgSucesso: string) => 
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(msgSucesso ? msgSucesso : "Item " + (props.operacao == EFORM.ADD ? "criado" : "alterado") + " com sucesso.", "success");
	}, [bananinhaDelegate])
	const handleError = React.useCallback((combinedErrors: string) => 
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(combinedErrors, "error");
	}, [bananinhaDelegate])
	const onInvalid = (state: any) => 
	{
		let erroMsg = '<ul>';

        erroMsg += bananinhaListError(state);
        
        erroMsg += '<ul>';
        
        handleError(erroMsg)
	}
	async function onSubmit(data:IFormStateEntidades)
	{
		setOnSubmiting(true);
		if (props.operacao == EFORM.ADD) {
			data.idQuemCadastrou = user.uid;
		} else {
			data.idQuemAlterou = user.uid;
		}
		try
		{

			if (!userRoleAdmin) {
				throw new Error('Usuário não tem permissão para enviar o formulário.');
			}
			
			var res: IRetornoAjaxEntidades;
			if (props.operacao == EFORM.ADD) {
				res = await EntController.repositorioCreate(data);
			} else {
				res = await EntController.repositorioUpdate(data);
			}
			if (res && (res.status == 200 || res.status == 201))
			{
				handleSuccess(res.message);
				setTimeout(() => {
					props.setOpenDialog(false);
					props.setEntidade(null);
				}, 5000);
				setOpen(false);
			}
			else
			{
				handleError(res.message);
			}
		}
		catch(e)
		{
			handleError(e.message);
		}
		finally
		{
			setOnSubmiting(false);
			props.callBack();
		}
	}

	React.useEffect(() =>
	{
		if(props.openDialog)
			setOpen(true)
	},[props.openDialog])

	return <>
		<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
		{user && props.entidade && 
			/* Seus outros elementos aqui ... */
			<AddEditComponent 
				ehDialog={true}
				tituloCaller={(props.operacao == EFORM.ADD ? "Adicionar" : props.listViews ? "Visualizar" : "Editar") + " Repositório"}
				onSubmitingCaller={onSubmiting} 
				handleSubmitCaller={handleSubmit(onSubmit, onInvalid)}
				openCaller={open} 
				listViews={props.listViews}
				onCloseCaller={() => {
					setOpen(false);
					props.setOpenDialog(false);
					props.setEntidade(null);
				}} 
			>
				{/* Aqui, você pode adicionar todos os elementos que você quer renderizar dentro do CustomModal */}
				<Grid item xs={12}>
					<Controller
						name="nome"
						control={control}
						rules={{
							required: validacao.requerido, 
							maxLength: { value:255, message:`${validacao.maxLength} 255`, }
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label="Nome *" 
								fullWidth
								size="small"
								inputProps={{
									maxLength:255,
									readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
								}}
								helperText={errors.nome ? errors.nome.message : null}
								error={!!errors.nome}
								aria-invalid={!!errors.nome}
							/>
						)}
					/>
				</Grid>					
				<Grid item xs={12}>
					<Controller
						name="bucket"
						control={control}
						rules={{
							required: validacao.requerido, 
							maxLength: { value:255, message:`${validacao.maxLength} 255`, }
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label="Bucket *" 
								fullWidth
								size="small"
								inputProps={{
									maxLength:255,
									readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
								}}
								helperText={errors.bucket ? errors.bucket.message : null}
								error={!!errors.bucket}
								aria-invalid={!!errors.bucket}
							/>
						)}
					/>
				</Grid>				
				<Grid item xs={12}>
					<Controller
						name="diretorio"
						control={control}
						rules={{
							required: validacao.requerido, 
							maxLength: { value:255, message:`${validacao.maxLength} 255`, }
						}}
						render={({ field }) => (
							<TextField 
								{...field}
								label="Diretório *" 
								fullWidth
								size="small"
								inputProps={{
									maxLength:255,
									readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
								}}
								helperText={errors.diretorio ? errors.diretorio.message : null}
								error={!!errors.diretorio}
								aria-invalid={!!errors.diretorio}
							/>
						)}
					/>
				</Grid>
				{/* ... e assim por diante */}
			</AddEditComponent>
			/* Outros elementos que você quiser ... */
		}
	</>
}
export default FormDialog;
